import React from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter as Router } from "react-router-dom";
import App from './App';
import reportWebVitals from './reportWebVitals';
import TranslationProvider from "./contexts/TranslationProvider";
import CartProvider from "./contexts/CartProvider";
import AuthProvider from "contexts/AuthProvider";
import ShiptoProvider from 'contexts/ShipToProvider';
import UserCountryProvider from 'contexts/UserCountryProvider';
import SiteConfigProvider from 'contexts/SiteConfigProvider';

const root = createRoot(document.getElementById('root')!);
root.render(
  <React.StrictMode>
    <Router>
      <TranslationProvider>
        <AuthProvider>
          <UserCountryProvider>
            <ShiptoProvider>
              <CartProvider>
                <SiteConfigProvider>
                  <App />
                </SiteConfigProvider>
              </CartProvider>
            </ShiptoProvider>
          </UserCountryProvider>
        </AuthProvider>
      </TranslationProvider>
    </Router>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
